var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Select from 'react-select';
import { ApplicationContext } from '../../../../ApplicationContext';
import GetTransmissionModesCommand from '../../../../commands/referenceData/GetTransmissionModesCommand';
import BasicFormGroup from '../BasicFormGroup/BasicFormGroup';
var TransmissionModeSelect = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled, subText = _a.subText, className = _a.className;
    // @ts-ignore
    var transmissionModeCollection = useContext(ApplicationContext).transmissionModeCollection;
    var intl = useIntl();
    var _b = useState(!transmissionModeCollection.firstFetchComplete), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (!transmissionModeCollection.firstFetchComplete) {
            var command = new GetTransmissionModesCommand();
            command.execute(transmissionModeCollection)
                .finally(function () { return setLoading(false); });
        }
    }, [transmissionModeCollection]);
    var options = transmissionModeCollection.list.map(function (mode) { return ({
        value: mode.id,
        label: mode.name,
        model: mode
    }); });
    var selectedOption = options.find(function (opt) { return opt.value === value; }) || null;
    return (React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'device.settings.smartErdTransmissionMode' }), htmlFor: "smartErdTransmissionModeId", className: className },
        React.createElement(Select, { className: "form-control select2", classNamePrefix: "select2", name: "smartErdTransmissionModeId", noOptionsMessage: function () { return intl.formatMessage({ id: 'label.noresults' }); }, isDisabled: disabled || loading, isLoading: loading, options: options, value: selectedOption, onChange: function (option) { return onChange(option ? option.value : undefined); }, menuPortalTarget: document.body, menuPosition: "fixed", styles: {
                menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
                control: function (base, state) { return (__assign(__assign({}, base), { backgroundColor: state.isDisabled ? '#E3EBF6' : base.backgroundColor })); },
                singleValue: function (base) { return (__assign(__assign({}, base), { color: '#0a426e' })); },
                option: function (base) { return (__assign(__assign({}, base), { color: '#0a426e' })); }
            } }),
        subText && (React.createElement("span", { className: "text-muted" }, subText))));
};
export default TransmissionModeSelect;
